import { ExpectedProps, ServerPropsFactory } from '@lib/factory/serverprops';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ICartItemToys } from '@services/store/helpers/cart';
import { NextPage } from 'next';
import { PageLayout } from '@components/PageLayout/PageLayout';
import { ToysList } from '@components/Pages/CartPage/ToysList';
import cn from 'classnames';
import { formatWithSpaces } from '@specs/helpers';
import s from './cartPage.module.scss';
import { useTranslation } from '@hooks/useTranslation';
export const getServerSideProps = ServerPropsFactory(async (props: ExpectedProps) => {
  const cartItems = props?.cookies?.cartItems ? JSON.parse(props.cookies.cartItems ?? '[]') as ICartItemToys[] : [];
  return {
    ...props,
    cartItems
  };
}, undefined, true);
interface PageProps extends ExpectedProps {
  cartItems: ICartItemToys[];
}
const Page: NextPage<PageProps> = ({
  cartItems
}) => {
  const [list, setList] = useState(cartItems);
  const {
    translate: tr
  } = useTranslation();
  const count = list.length;
  return <PageLayout data-sentry-element="PageLayout" data-sentry-component="Page" data-sentry-source-file="index.tsx">
            <div className={s.cartPage}>
                <div className={cn(s.cartPage__container, '_container')}>
                    <div className={s.cartPage__head}>
                        <h1 className={cn(s.cartPage__title, '_title')}>
                            {tr({
              id: 'cart.page.title'
            })}
                        </h1>
                        {!!count && <div className={s.cartPage__count}>
                                <FormattedMessage id='count.toys' values={{
              count: () => formatWithSpaces(count)
            }} />
                            </div>}
                    </div>
                    <ToysList list={list} setList={setList} data-sentry-element="ToysList" data-sentry-source-file="index.tsx" />
                </div>
            </div>
        </PageLayout>;
};
export default Page;